/* DeSiM 公式店 — 国家集合ページ（sections/main-collection.liquid）専用 JS。

   プラン種別タブ（∞完全無制限 / 日次リセット / 容量指定）は**絞り込み**。

   🔴 2026-09-08 運営レビュー: 以前の実装はタブを押しても「その種類の最初のカードへ
      スクロールする」だけで、一覧の中身は一切変わらなかった。設計上そういう意図
      （常に全カードが同時に見えている構成）だったが、押しても表示が同じに見えるため
      「無制限・日次リセット・容量指定どれを選んでも同じ内容になる」という指摘に
      なった。タブが選択肢の見た目をしている以上、実際に絞る方が期待に合う。

   判定はカードの `data-plan-kinds`（Liquid 側で付ける、空白区切り）。ラベル文字列
   での照合はしない（文言を変えた瞬間に黙って壊れるため）。
   絞った結果 0 件になるタブでは、空のリストではなく理由を出す。 */
(function () {
  var tabsWrap = document.querySelector('[data-ds-plan-tabs]');
  var list = document.querySelector('.ds-plan-list');
  if (!tabsWrap || !list) return;

  var tabs = Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-plan-kind]'));
  var cards = Array.prototype.slice.call(list.querySelectorAll('[data-plan-kinds]'));
  if (!tabs.length || !cards.length) return;

  /** 「このタブに該当するカードが無い」ときに出す行。初回に 1 つだけ作る。 */
  var empty = document.createElement('p');
  empty.className = 'ds-section__note ds-plan-list__empty';
  empty.hidden = true;
  list.parentNode.insertBefore(empty, list.nextSibling);

  function kindsOf(card) {
    return (card.getAttribute('data-plan-kinds') || '').split(/\s+/);
  }

  function apply(kind, label) {
    var shown = 0;
    cards.forEach(function (card) {
      var hit = kindsOf(card).indexOf(kind) !== -1;
      card.hidden = !hit;
      if (hit) shown++;
    });
    if (shown === 0) {
      empty.textContent = 'この行き先には「' + label + '」のプランがまだありません。';
      empty.hidden = false;
    } else {
      empty.hidden = true;
    }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-pressed', 'true');
      apply(tab.getAttribute('data-plan-kind'), (tab.textContent || '').trim());
    });
  });

  // 初期表示はマークアップ側で `is-active` が付いているタブに合わせる。
  // 🔴 JS 無効時は全カードが見えるだけ（hidden を付けるのはこの JS なので、
  //    絞り込みが動かない環境で商品が消えることはない）。
  var initial = tabs.filter(function (t) {
    return t.classList.contains('is-active');
  })[0];
  if (initial) apply(initial.getAttribute('data-plan-kind'), (initial.textContent || '').trim());
})();
